<ngx-ui-loader></ngx-ui-loader>
<div id="router-wrapper">
  <router-outlet></router-outlet>
</div>